import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppDashboard from '@/components/AppDashboard.vue';
import {DashboardModule} from '@/util/dashboard';


export default /*#__PURE__*/_defineComponent({
  __name: 'CRMDashboard',
  setup(__props, { expose: __expose }) {

const modules: DashboardModule[] = [
  {
    name: 'Alle',
    color: 'dark',
    desc: '',
    icon: 'mdi-account-multiple',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list'}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Kunden',
    color: 'success',
    desc: '',
    icon: 'mdi-account',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list', query: {status: 'kunde'}}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Interessenten',
    color: 'warning',
    desc: '',
    icon: 'mdi-account-star',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list', query: {status: 'interessent'}}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Lieferanten',
    color: 'info',
    desc: '',
    icon: 'mdi-truck-delivery',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list', query: {status: 'lieferant'}}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Umkreissuche',
    color: 'secondary',
    desc: 'Firmen im Umkreis anzeigen',
    icon: 'mdi-crosshairs-gps',
    actions: [{name: 'Öffnen', to: {name: 'customer_nearby_list'}}],
    hideInNav: false,
    badgeContent: null,
  },
];
__expose({
  AppDashboard,
  modules,
});

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(AppDashboard, { modules: modules })
    ], undefined, true),
    _: 1
  }))
}
}

})